<div class="sticky-bar" [ngClass]="{'five-day' : fiveDay}">
    <!-- Mobile -->
    <ng-container *ngIf="isMobile; else desktop">
        <div class="mobile-date-picker">
            <finder-button anchor="true" [ariaLabel]="labels.stickyArrowButton" (click)="openDatePickerModal()">
                <span>{{shortDateString}}</span>
                <finder-font-icon name="next-2"></finder-font-icon>
            </finder-button>
        </div>
        <finder-button
            anchor="true"
            class="all-filters"
            (click)="openMobileFilters()">
            {{labels.allFilters}} ({{filtersCount}})
        </finder-button>
    </ng-container>
    <!-- Desktop  -->
    <ng-template #desktop>
        <!-- Date Picker -->
        <ng-content></ng-content>
        <div class="date-range-container" *ngIf="fiveDay">
            <div class="date-range">
                <span class="date" *ngFor="let date of dateRange.formattedDates">{{date.day}}</span>
            </div>
        </div>
    </ng-template>
</div>
